import Modal from "react-modal";
import { i18n } from '../../../translate/i18n';

const { t }= i18n;

const defineHTTP400Message = ({ page, operationType }) => {
  switch (true) {
    case page === 'otb' && operationType === 'save_otb_version':
      return "Não foi possível salvar a versão. Verifique se os dados informados estão corretos e tente novamente.";

    case page === 'opportunities' && operationType === 'patch_finalized_opp':
      return "Não foi possível finalizar item."

    case page === 'opportunities' && operationType === 'patch_checkout_opp':
      return "Não foi possível enviar este item para checkout."

    case page === 'opportunities' && operationType === 'patch_removed_opp':
      return "Não foi possível remover este item."

    case page === 'opportunities' && operationType === "get_opp":
      return "Não foi possível carregar as oportunidades. \nPor favor, contate o suporte."

    default:
      return t("error400HTTPMessage");
  }
};

const defineHTTP404Message = ({ page, operationType }) => {
  switch (true) {
    case page === 'otb' && operationType === 'save_otb_version':
      return "Não foi possível encontrar o OTB ou a categoria informada."

    case page === 'opportunities' && operationType === 'patch_checkout_opp':
      return "Não foi possível identificar o item que você deseja enviar para checkout."

    case page === 'opportunities' && operationType === 'patch_finalized_opp':
      return "Não foi possível identificar o item que você deseja finalizar."
      
    case page === 'opportunities' && operationType === 'patch_removed_opp':
      return "Não foi possível identificar o item que você deseja remover."      

    case page === 'opportunities' && operationType === "get_opp":
      return "Não há oportunidades disponíveis. Por favor, contate o suporte."

    default:
      return t("error404HTTPMessage");
  }
};

const defineHTTP409Message = ({ page, hasMoreThanOneItem, operationType }) => {

  switch(true) {
    case page === 'order_history':
      return t("error409HTTPMessageHistoryPage");

    case page === 'purchase_recommendation_table':
      if (hasMoreThanOneItem) return t("error409HTTPMessagePlural")
      return t("error409HTTPMessageSingular");

    case page === 'opportunities' && operationType === 'patch_checkout_opp':
      return "Este item já consta na página de checkout."

    case page === 'opportunities' && operationType === 'patch_finalized_opp':
      return "Este item já foi finalizado."
      
    case page === 'opportunities' && operationType === 'patch_removed_opp':
      return "Este item já foi removido."
      
    default:
      return "Esta ação não pode ser realizada no momento."
  }
};

const defineHTTP422Message = ({ page, operationType }) => {
  switch (true) {
    case page === 'otb' && operationType === 'save_otb_version':
      return "Os dados da versão não puderam ser processados. Verifique os valores editados e tente novamente.";
      
    case page === 'opportunities' && operationType === 'patch_checkout_opp':
      return "Este item não pode ser enviado para checkout no momento.";

    case page === 'opportunities' && operationType === 'patch_finalized_opp':
      return "Este item não pode ser finalizado no momento.";

    case page === 'opportunities' && operationType === 'patch_removed_opp':
      return "Este item não pode ser removido no momento.";

    case page === 'opportunities' && operationType === 'get_opp':
      return "Não foi possível processar as oportunidades. Por favor, contate o suporte.";

    default:
      return "A solicitação não pôde ser processada. Verifique os dados e tente novamente.";
  }
};

export const ErrorModal = ({ actions, ctx, uiState  }) => {

  const { onClose } = actions || {};
  
  const { 
    page,
    details = [],
    errorStatus = 500,
    operationType,
    serverMessage = null,
    valueSentByClient = null
   } = ctx || {};

  const { isOpen, hasMoreThanOneItem = false } = uiState || {};

  const titleForErrorsMap = {
    400: (page === 'opportunities' || page === 'otb') ? "Operação não foi concluída" : t("checkInformation"),
    404: (page === 'opportunities' || page === 'otb') ? "Operação não foi concluída" : t("pageNotFound"),
    409: t("actionNotAllowed"),
    422: (page === 'opportunities' || page === 'otb') ? "Operação não foi concluída" : "Dados inválidos",
    500: t("errorHandling.heading"),
  };
 
  const responseForErrosMessageMap = {
    400: defineHTTP400Message({ page, operationType }),
    404: defineHTTP404Message({ page, operationType }),
    409: defineHTTP409Message({ page, hasMoreThanOneItem, operationType }),
    422: defineHTTP422Message({ page, operationType }),
    500: t("error500HTTPMessage"),
  };
  
  const handleClose = () => { 
    if (typeof onClose === "function") { 
      onClose(false); 
    } 
  };  
  
  const statusCode = Number(errorStatus) || 500;
  
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "1rem",
          textAlign: "center",
          borderRadius: "8px",
          blockSize: "auto",
          overflow: 'scroll'
        }
      }}
      contentLabel="Erro"
    >
      <div style={{ inlineSize: '100%' }}>
        <h2 style={{ color: "#e75d0d", marginBottom: "1rem" }}>
          {titleForErrorsMap[statusCode] || "Erro desconhecido"}
        </h2>

        <p style={{ fontSize: "1rem", color: "#333", marginBottom: "1rem" }}>
          {serverMessage || responseForErrosMessageMap[statusCode] || "Ocorreu um erro inesperado. Tente novamente."}
        </p>

        {!!valueSentByClient && (
          <hgroup>
          <p style={{ fontSize: "1rem", color: "#333", marginBottom: "1rem" }}>
            {`Você digitou: ${valueSentByClient}` || ""}
          </p>

          <p style={{ fontSize: "0.8rem", color: "#333", marginBottom: "1rem" }}>
            {"Por favor, redija a resposta usando os caracteres permitidos."}
          </p>    
          </hgroup>
        )}

        {statusCode === 409 && page !== 'opportunities' && details?.length > 0 && (
          <div style={{ textAlign: "left", inlineSize: '100%' }}>
            {Object.entries(
              details.reduce((acc, item) => {
                const key = item.orderId ?? 'sem pedido';
                if (!acc[key]) acc[key] = [];
                acc[key].push(item);
                return acc;
              }, {})
            ).map(([orderId, products]) => (
              <div key={orderId}>
                <p style={{ fontSize: "0.85rem", color: "#333", fontWeight: "bold", paddingInlineStart: '1rem' }}>
                  {`Número do pedido: ${orderId}`}
                </p>
                <ul>
                  {products.map(item => (
                    <li style={{ fontSize: "0.8rem" }} key={item.productId}>
                      {item.productName}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        <button 
          onClick={handleClose} 
          style={{
            marginTop: "1.5rem",
            padding: "0.5rem 1.5rem",
            backgroundColor: "#e75d0d",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};
